module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-alert', [_vm._v(_vm._s(_vm.error.message))]), _vm._v(" "), _c('v-card', [_c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "headers": _vm.headers,
      "items": _vm.items,
      "options": _vm.pagination,
      "server-items-length": _vm.totalItems,
      "loading": _vm.loading,
      "footer-props": _vm.footerProps
    },
    on: {
      "update:options": function($event) {
        _vm.pagination = $event
      },
      "update:items-per-page": _vm.getItemPerPage
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('td', [_vm._v(_vm._s(props.item.identifier))]), _vm._v(" "), _c('td', [(props.item.config.logo) ? _c('img', {
          attrs: {
            "width": "125",
            "src": props.item.config.logo
          }
        }) : _vm._e(), _vm._v(" " + _vm._s(props.item.config.brandName))]), _vm._v(" "), _c('td', _vm._l((_vm.countryNames(props.item)), function(name) {
          return _c('div', {
            key: name
          }, [_c('isrs-flag', {
            attrs: {
              "country": name,
              "squared": false
            }
          }), _vm._v("\n            " + _vm._s(name) + "\n          ")], 1)
        }), 0), _vm._v(" "), _c('td', [_c('ul', [_c('li', [_c('router-link', {
          attrs: {
            "to": ("/returnshopportals/" + (props.item.identifier))
          }
        }, [_vm._v("Settings")])], 1)])])]
      }
    }])
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /export/jenkins/workspace/stage-isrs-frontend-mb_master/~/vue-loader/lib/template-compiler?{"id":"data-v-59477505"}!/export/jenkins/workspace/stage-isrs-frontend-mb_master/~/vue-loader/lib/selector.js?type=template&index=0!./client/views/GetReturnportalParcelnumberContainers.vue
// module id = 937
// module chunks = 1